import { FUNC_DEFAULT } from 'constants';
import useProfile from 'features/profile2.0/hooks/useProfile';
import { isArray, isFunction } from 'lodash';
import { useEffect } from 'react';
import useEvent from './useEvent';

const useAutoShowEventModal = ({
  screenId,
  params,
  modalStyles,
  modalOptions,
  isForceToCheckEventEligible,
  isPreventAutoShowEventModal = false,
  conditions = [],
  callback = FUNC_DEFAULT,
}) => {
  const { isProfileKYC } = useProfile();

  const { isShowEvent, showEventModal } = useEvent({
    screenId,
    params,
    modalStyles,
    modalOptions,
    isForceToCheckEventEligible,
    isPreventAutoShowEventModal,
  });

  useEffect(() => {
    if (isPreventAutoShowEventModal) return;
    if (isProfileKYC) return;
    if (isArray(conditions) && conditions?.includes(true)) return;
    if (!isShowEvent) {
      if (isFunction(callback)) {
        callback?.();
      }
      return;
    }
    if (isFunction(showEventModal)) {
      showEventModal?.();
    }
  }, [isProfileKYC, isShowEvent, isPreventAutoShowEventModal, ...conditions]);

  return { showEventModal: isShowEvent ? showEventModal : FUNC_DEFAULT };
};

export default useAutoShowEventModal;
